import {
  REQUEST_CAROUSEL,
  RECEIVE_CAROUSEL
} from '../actions/CarouselActions';

const PropsInitialState = {
  items: []
};

function posts(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case REQUEST_CAROUSEL: {
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    }
    case RECEIVE_CAROUSEL: {
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        lastUpdated: action.receivedAt
      });
    }
    default:
      return state;
  }
}

function CarouselReducer(state = PropsInitialState, action) {
  switch (action.type) {
    case REQUEST_CAROUSEL:
    case RECEIVE_CAROUSEL: {
      return Object.assign({}, state, posts(state, action));
    }
    default: {
      return state;
    }
  }
}

export {
  CarouselReducer
};


// WEBPACK FOOTER //
// ./src/reducers/CarouselReducer.js